"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Alert_1 = __importDefault(require("@material-ui/lab/Alert"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const prop_types_1 = __importDefault(require("prop-types"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const DocumentForm_1 = __importDefault(require("./DocumentForm"));
const OrderedDocumentList_1 = __importDefault(require("./OrderedDocumentList"));
const RenderOrderedDocumentField = (props) => {
    const { field: { value, name: fieldName }, form: { setFieldValue }, listTitleDesc, listTitleItem, isFile, addDocument, } = props;
    const [listItems, setListItems] = react_1.useState(value || []);
    const [newDocIds, setNewDocIds] = react_1.useState([]);
    const [documentError, setDocumentError] = react_1.useState(false);
    const [oldDocsRemoved, setOldDocsRemoved] = react_1.useState(false);
    react_1.useEffect(() => {
        if (Array.isArray(value)) {
            setListItems(value);
        }
    }, [value]);
    const submit = async (url, name) => {
        const newDoc = {
            name,
            url,
            order: listItems.length + 1,
        };
        try {
            const newDocument = await addDocument(newDoc);
            if (newDocument) {
                const arr = [...listItems, newDocument];
                //keeping track of new added documents
                setNewDocIds([...newDocIds, newDocument.id]);
                setFieldValue('editedDocument', true);
                setListItems(arr);
                setFieldValue(fieldName, arr); //field
            }
            else {
                setDocumentError(true);
            }
        }
        catch (error) {
            setDocumentError(true);
        }
    };
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(Grid_1.default, { container: true, spacing: 1 },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(Typography_1.default, { variant: "subtitle1" },
                    listTitleDesc,
                    " ",
                    listItems.length,
                    " ",
                    listTitleItem)),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                documentError && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement(Alert_1.default, { variant: "filled", severity: "error", icon: false, onClose: () => {
                            setDocumentError(false);
                        } }, "There is an error from this file submission. Please double check that it is a publicly accessible file."))),
                react_1.default.createElement(OrderedDocumentList_1.default, { listItems: listItems, isFile: isFile, onChange: (res) => {
                        if (!res.destination)
                            return;
                        const items = Array.from(listItems);
                        const [reorderedItem] = items.splice(res.source.index, 1);
                        items.splice(res.destination.index, 0, reorderedItem);
                        const updatedItems = items.map((item, index) => ({
                            ...item,
                            order: index + 1,
                        }));
                        setListItems(updatedItems);
                        setFieldValue(fieldName, updatedItems);
                    }, onEditItem: (index, newName) => {
                        const arr = listItems.map((item, i) => (i === index ? { ...item, name: newName } : item));
                        setListItems(arr);
                        setFieldValue(fieldName, arr);
                    }, onDeleteItem: (index) => {
                        const itemToDelete = listItems[index];
                        if (itemToDelete && newDocIds.includes(itemToDelete.id)) {
                            //this checks if there are no more new documents
                            const aux1 = newDocIds.filter((id) => id !== itemToDelete.id);
                            setNewDocIds(aux1);
                            if (aux1.length === 0 && !oldDocsRemoved) {
                                setFieldValue('editedDocument', false);
                            }
                        }
                        else {
                            setFieldValue('editedDocument', true);
                            setOldDocsRemoved(true);
                        }
                        const arr = listItems.filter((_, i) => i !== index);
                        setListItems(arr);
                        setFieldValue(fieldName, arr);
                    } })),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(DocumentForm_1.default, { onItemSubmit: (url, name) => submit(url, name) })))));
};
RenderOrderedDocumentField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    form: prop_types_1.default.any.isRequired,
    listTitleDesc: prop_types_1.default.string,
    listTitleItem: prop_types_1.default.string,
    isFile: prop_types_1.default.bool,
    addDocument: prop_types_1.default.func,
};
exports.default = RenderOrderedDocumentField;
